import { motion } from 'framer-motion';
import type { ChatMessage } from '@/types';
import { MemberProposalCard } from './MemberProposalCard';

interface Props {
  message: ChatMessage;
}

export function MessageBubble({ message }: Props) {
  const isUser = message.role === 'user';

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className={`flex flex-col ${isUser ? 'items-end' : 'items-start'} px-4 pb-2`}
    >
      <div
        className={`max-w-[82%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap ${
          isUser
            ? 'bg-primary text-primary-foreground rounded-br-sm'
            : 'bg-card border border-border text-foreground rounded-tl-sm'
        }`}
      >
        {message.content || (
          <span className="text-muted-foreground italic">…</span>
        )}
      </div>

      {message.memberProposal && (
        <MemberProposalCard
          proposal={message.memberProposal}
          messageId={message.id}
        />
      )}
    </motion.div>
  );
}
